import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  const handlePurchase = () => {
    window.location.href = 'https://pay.hotmart.com/D104438066M';
  };
  return <section className="py-16 md:py-20 bg-gradient-to-b from-[#3D1F2E] to-[#2D1520] text-white relative overflow-hidden" data-id="element-157">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-158">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-pink-500 rounded-full blur-3xl" data-id="element-159"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-rose-400 rounded-full blur-3xl" data-id="element-160"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-161">
        <div className="text-center mb-8 md:mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6" data-id="element-163">
            📦 Lo que recibís hoy
          </h2>
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-lg text-gray-300 mb-6 md:mb-8" data-id="element-164">
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-165">
              ✔ 6 eBooks profesionales
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-166">
              ✔ 3 bonos estratégicos
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-167">
              ✔ Protocolos claros
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-168">
              ✔ Guías prácticas
            </span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-pink-300" data-id="element-169">
            🎯 Total: 9 recursos completos
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-2xl mx-auto" data-id="element-170">
          <div className="bg-[#BE185D] text-white p-4 text-center font-bold uppercase tracking-widest text-sm" data-id="element-171">
            Oferta por tiempo limitado
          </div>
          <div className="p-6 md:p-12 text-center" data-id="element-172">
            <p className="text-gray-500 text-base md:text-lg mb-2" data-id="element-173">
              Precio regular:{' '}
              <span className="line-through decoration-[#BE185D] decoration-2" data-id="element-174">
                ARS $98.990
              </span>
            </p>
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-175">
              <span className="text-5xl md:text-7xl font-black text-gray-900 tracking-tighter" data-id="element-176">
                $39.990
              </span>
              <span className="text-lg md:text-xl font-bold text-gray-500 self-end mb-3 md:mb-4" data-id="element-177">
                ARS
              </span>
            </div>
            <p className="text-[#BE185D] font-bold bg-pink-50 inline-block px-4 py-1 rounded-full mb-6 md:mb-8 text-sm md:text-base" data-id="element-178">
              🔥 Ahorrás un 60% HOY
            </p>

            <Button onClick={handlePurchase} size="xl" fullWidth className="mb-6 text-lg md:text-2xl py-6 md:py-8 shadow-xl shadow-pink-500/20" data-id="element-179">
              👉 OBTENER MI MEGAPACK AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-180">
              <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-181" />
              <span data-id="element-182">Pago 100% Seguro y Encriptado</span>
            </div>
            <div className="flex items-center justify-center gap-4 mt-4 opacity-70" data-id="element-183">
              <img src="https://cdn.magicpatterns.com/uploads/iTwZx4YLA45eKGj5ZAgqDd/hotmart.jpg" alt="Hotmart" className="h-8 rounded" data-id="element-184" />
              <img src="https://cdn.magicpatterns.com/uploads/fL9kACheWktd2dhJwcnkzQ/mercado_pago.jpg" alt="Mercado Pago" className="h-8 rounded" data-id="element-185" />
            </div>
          </div>
          <div className="bg-pink-50 p-4 md:p-6 border-t border-pink-100" data-id="element-186">
            <div className="flex flex-col md:flex-row items-center gap-4 text-left" data-id="element-187">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-188">
                <ShieldCheck className="w-8 h-8 text-green-600" data-id="element-189" />
              </div>
              <div data-id="element-190">
                <h4 className="font-bold text-gray-900" data-id="element-191">
                  Garantía sin riesgo de 7 días
                </h4>
                <p className="text-sm text-gray-600" data-id="element-192">
                  Si sentís que el material no te aporta claridad, estructura o
                  valor práctico, te devolvemos el 100% del dinero. Sin
                  preguntas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}